import { useAdvancedSearchUX } from 'features/knowledgeDocumentViewer/components/advancedSearch/contexts/AdvancedSearchUXContext'
import { PLACEHOLDER_MAP } from 'features/knowledgeDocumentViewer/components/advancedSearch/utils/constants'
import type {
  AgenticConversationTurn,
  ViewMode,
} from 'features/knowledgeDocumentViewer/types'
import type { FavoriteSearch } from 'features/knowledgeDocumentViewer/utils/favoriteSearchesStorage'
import type { SearchQueryHistoryEntry } from 'features/knowledgeDocumentViewer/utils/searchQueryHistoryStorage'
import React from 'react'
import type { DocumentsViewerContentFilter } from 'routes/documents/-searchParams'

import { AgenticSearchResultsHeader } from './AgenticSearchResultsHeader'
import { SearchToolbar } from './SearchToolbar'

type SearchInputChangeEvent = React.ChangeEvent<
  HTMLInputElement | HTMLTextAreaElement
>

export interface UnifiedSearchHeaderProps {
  isLinkedDocsMode: boolean
  isAgenticSearchExperience: boolean
  contentFilter: DocumentsViewerContentFilter
  searchInput: string
  onSearchChange: (event: SearchInputChangeEvent) => void
  onSearchKeyDown: (event: React.KeyboardEvent) => void
  onSearchSubmit: () => void
  viewMode: ViewMode
  onViewModeChange: (value: string | number) => void
  suggestions: SearchQueryHistoryEntry[]
  onSuggestionSelect: (query: string) => void
  onClearHistory: () => void
  favoriteSearches: FavoriteSearch[]
  isSearchFavorited: (query: string) => boolean
  onToggleSearchFavorite: (query: string, contentFilter: string) => void
  agenticTurns: AgenticConversationTurn[]
  onAgenticSearchKeyDown: (event: React.KeyboardEvent) => void
  onAgenticSearchSubmit: () => void
}

export function UnifiedSearchHeader({
  isLinkedDocsMode,
  isAgenticSearchExperience,
  contentFilter,
  searchInput,
  onSearchChange,
  onSearchKeyDown,
  onSearchSubmit,
  suggestions,
  onSuggestionSelect,
  onClearHistory,
  favoriteSearches,
  isSearchFavorited,
  onToggleSearchFavorite,
  agenticTurns,
  onAgenticSearchKeyDown,
  onAgenticSearchSubmit,
}: UnifiedSearchHeaderProps): React.ReactElement {
  const { searchMode } = useAdvancedSearchUX()

  if (isLinkedDocsMode) {
    return <></>
  }

  if (isAgenticSearchExperience && searchMode === 'agentic') {
    return (
      <AgenticSearchResultsHeader
        turns={agenticTurns}
        searchInput={searchInput}
        onSearchChange={onSearchChange}
        onSearchKeyDown={onAgenticSearchKeyDown}
        onSearchSubmit={onAgenticSearchSubmit}
        contentFilter={contentFilter}
      />
    )
  }

  return (
    <SearchToolbar
      searchInput={searchInput}
      onSearchChange={onSearchChange}
      onSearchKeyDown={onSearchKeyDown}
      onSearchSubmit={onSearchSubmit}
      placeholder={PLACEHOLDER_MAP[contentFilter]}
      suggestions={suggestions}
      onSuggestionSelect={onSuggestionSelect}
      onClearHistory={onClearHistory}
      favoriteSearches={favoriteSearches}
      isSearchFavorited={isSearchFavorited}
      onToggleSearchFavorite={onToggleSearchFavorite}
      contentFilter={contentFilter}
    />
  )
}
